import { render, staticRenderFns } from "./AccessRestrictedButtonGroup.vue?vue&type=template&id=4d57a728&scoped=true&"
import script from "./AccessRestrictedButtonGroup.vue?vue&type=script&lang=js&"
export * from "./AccessRestrictedButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./AccessRestrictedButtonGroup.vue?vue&type=style&index=0&id=4d57a728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d57a728",
  null
  
)

export default component.exports